// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import FilterSelectController from "./filter_select_controller"
application.register("filter-select", FilterSelectController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import PreviewController from "./preview_controller"
application.register("preview", PreviewController)
